import Page from "src/components/Report/Page";
import HeaderFactors from "./components/Factors/HeaderFactors";
import ExplainFactor from "./components/Factors/ExplainFactor";
import SpaceBetweenTables from "./components/Factors/SpaceBetweenTables";
import Table6 from "./components/Factors/Table/Table6";
import Table7 from "./components/Factors/Table/Table7";
import { useState } from "react";

const PageG3 = ({ reload }) => {
  const [masouliatMaliScore, setMasouliatMaliScore] = useState("")
  const [forms, setForms] = useState("")
  return (
    <>
      <Page pageNumber={27}>
        <HeaderFactors
          numberFactors="عامل ششم"
          titelFactors="مسئوليت منابع مالی"
          maxValue="40"
          jsValue={masouliatMaliScore}
        />
        <ExplainFactor
          text="به حدود مسئولیت در مورد نگهداری، کنترل، دریافت، پرداخت واستفاده از وجوه نقد واوراق بهادار و
          انجام و کنترل عملیات مالی و اختیارات تصویب هزینه های جاری و سرمایه‌ای، سفارشات و نگهداری
          اموال ودارایی‌ها اشاره دارد."
        />
        <Table6 masouliatMaliScore={masouliatMaliScore} setMasouliatMaliScore={setMasouliatMaliScore} reload={reload}/>
        <SpaceBetweenTables />
        <HeaderFactors
          numberFactors="عامل هفتم"
          titelFactors="فرم ها و گزارشات"
          maxValue="30"
          jsValue={forms}
        />
        <ExplainFactor
          text="مسئولیت در قبال جمع آوری، ثبت، تهیه وتنظیم آمار اطلاعات و سوابق و گزارش های عملیاتی، مالی،
          فنی، آموزشی یا پرسنلی است."
        />
        <Table7 setForms={setForms} forms={forms} reload={reload}/>
      </Page>
    </>
  );
};

export default PageG3;
